import React from "react";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

export const GreenRedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "red", // OFF thumb
    "& + .MuiSwitch-track": {
      backgroundColor: "red", // OFF track
    },

    "&.Mui-checked": {
      color: "green", // ON thumb
      "& + .MuiSwitch-track": {
        backgroundColor: "green", // ON track
      },
    },

    // Disabled state (unchecked)
    "&.Mui-disabled": {
      color: "#ff9999", // light red thumb
      "& + .MuiSwitch-track": {
        backgroundColor: "#ffcccc", // light red track
        opacity: 1,
      },
    },

    // Disabled & checked (on)
    "&.Mui-checked.Mui-disabled": {
      color: "#99e699", // light green thumb
      "& + .MuiSwitch-track": {
        backgroundColor: "#ccffcc", // light green track
        opacity: 1,
      },
    },
  },
}));
